import { useTheme } from '@mui/material';
import { FieldError } from 'react-hook-form';

type Props = {
  error: FieldError | undefined;
};
const TextFormError = (props: Props) => {
  const { error } = props;
  const { palette } = useTheme();

  if (!error?.message) {
    return null;
  }
  return <small style={{ color: palette.error.light, fontSize: '0.875rem' }}>{error.message}</small>;
};

export default TextFormError;
